import { render, staticRenderFns } from "./NewStaffReferralCode.vue?vue&type=template&id=2ecae596&"
import script from "./NewStaffReferralCode.vue?vue&type=script&lang=js&"
export * from "./NewStaffReferralCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports